import React, { useState } from 'react';

import { t } from 'i18next';
import { Nav } from 'react-bootstrap';
import { Arrow90degLeft, ChevronDoubleRight, Folder } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { useLayoutActions } from '../store';

import type { MenuItem } from './types';
interface Props {
  menuRoot: Array<MenuItem>;
  hideBackParent?: (value: boolean) => void;
}

const MenuTree = React.memo((props: Props) => {
  const [parent, setParent] = useState<Array<MenuItem>>([]);
  const [visible, setVisible] = useState(props.menuRoot);
  const [hideBack, setHideBack] = useState(false);

  const { closeMenu } = useLayoutActions();

  const hide = (value: boolean) => {
    setHideBack(value);
  };

  if (parent.length > 0) {
    function label(arg0: string): React.ReactNode {
      throw new Error('Function not implemented.');
    }

    return (
      <>
        {!hideBack && (
          <Link
            to="#"
            className="list-group-item d-flex justify-content-between align-items-center"
            onClick={() => {
              setVisible(parent);
              setParent([]);
              if (props.hideBackParent) {
                props.hideBackParent(false);
              }
            }}
          >
            <div>{t('common.label.back')} </div>
            <Arrow90degLeft className="ms-3" />
          </Link>
        )}

        <MenuTree menuRoot={visible} hideBackParent={hide} />
      </>
    );
  }

  const items = visible.map((x, index) => {
    if (x.children && x.children.length > 0) {
      return (
        <Link
          key={index}
          to="#"
          className="list-group-item d-flex justify-content-between align-items-center"
          onClick={() => {
            if (x.children && x.children.length > 0) {
              setParent(visible);
              setVisible(x.children);
              if (props.hideBackParent) {
                props.hideBackParent(true);
              }
            }
          }}
        >
          <div>{t(`appMenu.${x.id}`)}</div>
          <Folder className="ms-3"></Folder>
        </Link>
      );
    }

    // esto es para los demás items
    if (x.url) {
      return (
        <Nav.Link
          key={index}
          as={Link}
          className="list-group-item d-flex justify-content-between align-items-center"
          to={x.url}
          onClick={() => {
            closeMenu();
          }}
        >
          <div>{t(`appMenu.${x.id}`)}</div>
          <ChevronDoubleRight className="ms-3" />
        </Nav.Link>
      );
    }
  });

  return <>{items.filter(Boolean)}</>;
});
export default MenuTree;
